import { styled, css } from 'styled-components';
export const Wrapper = styled.div `
  list-style: none;
  border-radius: ${({ theme }) => `${theme.borders.radiusMedium}px`};
  background: ${({ type, theme }) => (type === 'tooltip' ? theme.colors.black_1 : theme.colors.grey00_6)};
  color: ${({ type, theme }) => (type === 'tooltip' ? theme.colors.grey00_1 : theme.colors.black_1)};
  ${({ theme }) => theme.typography.textSmall};
  z-index: ${({ $zIndex }) => $zIndex || 1011};
  max-width: ${({ type }) => type !== 'popper' && '300px'};

  & a {
    color: ${({ theme }) => theme.colors.link100};

    &:hover {
      color: ${({ theme }) => theme.colors.link120};
      text-decoration: underline;
    }
  }
  ${({ type, theme }) => type === 'popper' &&
    css `
      ${theme.shadows.medium};
    `}
`;
export const Content = styled.div `
  ${({ $autoSize }) => !$autoSize &&
    css `
      max-height: 200px;
      box-sizing: border-box;
    `}
  padding: ${({ $contentPadding }) => $contentPadding && '8px 16px'};
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
`;
export const Trigger = styled.div `
  display: inline-flex;
`;
